<template>
  <div>
    <van-pull-refresh :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
      >
        <van-steps direction="vertical" :active="-1" v-if="lastList.length && lastList.length > 0">
          <van-step v-for="(item, index) in lastList" :key="index" :class="lastList.length && lastList.length === 1 ? 'nones' : ''">
            <h3 class="stepHThree">{{item.time}}</h3>
            <vanCollapseContent :list = item.children ></vanCollapseContent>
          </van-step>
        </van-steps>
        <div v-else class="noLastList">
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import vanCollapseContent from './PurchaseVanCollapseContent.vue'
import { userOrderList } from '@/api/orther.js'
export default {
  name: 'purchasers',
  components: { vanCollapseContent },
  props: {
    paramsList: {
      type: Object
    },
    list: {
      type: Array
    },
    listFlags: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      newlists: [],
      // 刷新节流阀
      refreshingFlag: false,
      lastListTime: [],
      lastList: [],
      finishedText: '没有更多采购订单了',
      testList: [
        { orderId: '12', purNo: '12', status: '12', quantity: '12', totalAmount: '121' }
      ]
    }
  },
  watch: {
    list (e) {
      this.lastList = []
      this.lastListTime = []
      if (e && e.length > 0) {
        e.forEach(item => {
          if (this.lastListTime.indexOf(item.createTime) === -1) {
            this.lastListTime.push(item.createTime)
          }
        })
      }
      this.lastListTime.forEach(item => {
        this.lastList.push({ time: item, children: [] })
      })
      this.lastList.forEach(item => {
        e.forEach(items => {
          if (items.createTime === item.time) {
            item.children.push(items)
          }
        })
      })
    },
    listFlags: {
      handler: function (val) {
        if (val === 'three') {
          this.finishedText = '查询中...'
        } else if (val === 'two') {
          this.finishedText = '今天没有进行采购哦'
        } else {
          this.finishedText = '没有更多采购订单了'
        }
        this.onRefreshs()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    // 触底获取信息
    async onLoad () {
      this.newlists = []
      const { data: res } = await userOrderList(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      const { rows } = res.extend
      this.newlists.push(...rows)
      this.$emit('changList', {
        list: this.newlists,
        type: 'add'
      })
      this.loading = false
      if (rows && rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    // 下拉刷新
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.lists = []
      this.$emit('changList', {
        list: [],
        type: 'refreshs'
      })
      this.paramsList.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .nones {
    /deep/.van-step__circle-container {
      display: none;
    }
    /deep/.van-step__line {
      display: none;
    }
  }
  /deep/.van-step__title {
    .stepHThree {
      margin-bottom: 15px;
    }
  }
  .noLastList {
  }
</style>
